/**
 * Shim para DashboardLayout (intocável): não força mais layout “Sindirepa-only”.
 * Preferir useInstitutionAccess() em código novo.
 */
interface SindirepaAccess {
  isSindirepaOnly: boolean;
  institutionId: string | null;
  loading: boolean;
}

export function useSindirepaAccess(): SindirepaAccess {
  return {
    isSindirepaOnly: false,
    institutionId: null,
    loading: false,
  };
}
